'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            componentId: '@'
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller($q, publicObjectsService, $uibModal) {
            var vm = this;

            vm.saveLoading = true;
            vm.imageModalOpened = false;
            vm.editable = false;

            vm.updateSurveyFillError = false;
            vm.updateSurveyFillErrorMessage = '';
            vm.updateSurveyFillSuccess = false;
            vm.updateSurveyFillSuccessMessage = '';

            vm.title = 'Küsimustiku andmete täitmine';

            vm.showErrors = false;

            vm.$onInit = function () {
                publicObjectsService.getSurveysByComponent(vm.componentId).then(function (response) {
                    vm.editable = response.data.editable;
                    vm.surveysData = response.data.surveyData;
                    vm.surveysData.webEntry = {};
                    vm.modal = {
                        form: {},
                        data: {},
                        objectId: vm.surveysData.versionId,
                        componentId: vm.surveysData.componentId,
                        classifierId: vm.surveysData.classifierId
                    };

                    vm.saveLoading = false;
                });
            };

            vm.showFileModal = function (question, file) {
                vm.modal.data = $.extend({}, file || {
                    name: {
                        est: {},
                        eng: {},
                        rus: {}
                    },
                    question: question
                });

                $uibModal.open({
                    template: require('./modal/survey-question-image-files-modal.html'),
                    controller: require('./modal/survey-question-image-files-modal.directive'),
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        data: function data() {
                            return vm.modal;
                        }
                    }
                }).result.then(function (response) {
                    angular.forEach(question.image_files, function (img) {
                        if (img.id === response.id) {
                            img.name = response.name;
                            img.image_created_date = response.image_created_date ? new Date(response.image_created_date) : null;
                        }
                    });
                    vm.showErrors = false;
                }).catch(function (reason) {
                    console.log('Modal dismissed with reason', reason);
                });
            };

            vm.chooseAnswer = function (answer, question) {
                question.answer.answer = answer.name;
                question.notFilled = false;
            };

            vm.removeFile = function (question, file) {
                var index = file ? question.image_files.indexOf(file) : -1;
                if (index !== -1) {
                    if (window.confirm('Kas oled kindel?')) {
                        question.image_files.splice(index, 1);
                    }
                }
            };

            vm.save = function () {
                if (confirm('Kas oled kindel?')) {
                    validateForm().then(function () {
                        vm.saveLoading = true;
                        publicObjectsService.saveComponentSurvey(angular.copy(vm.surveysData)).then(function (response) {
                            if (response.data !== 'ok') {
                                vm.updateSurveyFillError = true;
                                vm.updateSurveyFillErrorMessage = 'Salvestamine ebaõnnestus';
                            } else {
                                vm.updateSurveyFillSuccess = true;
                                vm.updateSurveyFillSuccessMessage = 'Salvestamine õnnestus';
                            }
                            vm.saveLoading = false;
                        });
                    });
                }
            };

            function validateForm() {
                return $q(function (resolve, reject) {
                    vm.checkedValidation = true;
                    vm.showErrors = false;
                    vm.suveyNotFilled = false;
                    if (vm.objectSurveyForm.$invalid || vm.suveyNotFilled) {
                        vm.showErrors = true;
                        reject();
                    } else {
                        resolve();
                    }
                });
            }
        },
        template: require('./surveys-fill.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/fill_component_surveys/surveys-fill.directive.js
 **/